import React from "react";
import {inject, observer} from "mobx-react";
import {Box, Tab, Tabs} from "@material-ui/core";
import {IManagementStore} from "Stores/Management/types";
import {Permission} from "@src/Interfaces/Entity/Permission";
import filterByTableColumns from "@src/Tools/filterByTableColumns";
import {observable, computed} from "mobx";
import PermissionsTable from "./PermissionsTable/PermissionsTable";
import {Values} from "@src/Tools/Values";
import {IAuthStore} from "@src/Stores/Auth/types";
import {FullWidthFlexBox} from "@src/Shared/Components/FullWidthFlexBox";
import {ItemListPageContentWrapper, ItemListPageTabWrapper} from "@src/Shared/Layout/styles";
import {AddButton} from "@src/Shared/Components/AddButton/AddButton";
import FullWidthSearch from "@src/Shared/Components/FullWidthSearch/FullWidthSearch";
import {STGrid} from "@src/Components/Pages/Main/Content/Locations/LocationsContent/styles";
import ResultsAreEmptyLabel from "@src/Components/Ui/ResultsAreEmpty";
import {
    PermissionDialog
} from "@src/Components/Pages/Main/Content/Permissions/PermissionsContent/PermissonDialog/PermissionDialog";
import { IApplicationsStore } from "@src/Stores/Applications/types";

interface IProps {
    auth?: IAuthStore;
    management?: IManagementStore;
    applicationsStore?: IApplicationsStore;
}

@inject("auth", "management", "applicationsStore")
@observer
class PermissionsContent extends React.Component<IProps> {
    @observable searchText: string = "";
    @observable showPermissionDialog: boolean = false;
    @observable editPermission: Permission = null;

    @computed get filteredPermissions() {
        return filterByTableColumns<Permission>(
            this.props.management.permissions,
            this.searchText
        );
    }

    handleChange = (event: any) => {
        this.searchText = event.target.value;
    };

    handleAddPermissionDialog() {
        this.showPermissionDialog = !this.showPermissionDialog;
    };

    onEditButtonClick(permission: Permission) {
        this.editPermission = permission;
        this.showPermissionDialog = true;
    }

    async onPermissionModalConfirm() {
        this.showPermissionDialog = false;
        this.editPermission = null;
    }

    onPermissionModalCancel() {
        this.editPermission = null;
        this.showPermissionDialog = false;
    }

    render() {
        return (
            <>
                <FullWidthFlexBox>
                    <ItemListPageTabWrapper>
                        <Tabs
                            value={0}
                            indicatorColor="primary"
                            textColor="primary"
                            variant={"standard"}
                        >
                            <Tab label={Values.getLocalizationValue("permissions")}/>
                        </Tabs>
                    </ItemListPageTabWrapper>

                    {this.props.auth.user.location.primary &&
                        <AddButton
                            onClick={() => this.handleAddPermissionDialog()}
                            text={Values.getLocalizationValue("addPermission")}
                        />
                    }
                </FullWidthFlexBox>

                <ItemListPageContentWrapper>
                    <Box>
                        <FullWidthSearch
                            value={this.searchText}
                            onChange={(text: string) => this.handleChange(text)}
                        />

                        <STGrid item xs>
                            {this.filteredPermissions.length > 0 ? (
                                <PermissionsTable
                                    permissions={this.filteredPermissions}
                                    onEditButtonClick={this.onEditButtonClick.bind(this)}
                                />
                            ) : (
                                <ResultsAreEmptyLabel/>
                            )}
                        </STGrid>
                    </Box>
                </ItemListPageContentWrapper>

                {this.showPermissionDialog &&
                    <PermissionDialog
                        initialValues={this.editPermission}
                        onConfirm={() => this.onPermissionModalConfirm() }
                        onClose={() => { this.onPermissionModalCancel() }}
                        isOpened={this.showPermissionDialog}
                    />
                }
            </>
        );
    }
}

export default PermissionsContent;
